export class permissionReportRequest  {
    isM365Connected : boolean = false;
    resourceIdentifier: string = '';
    reportStyle: string = '';
  }